import workItemDlgMul from "./workItemDlgMul.js";
import workItemTimeDlgMul from "./workItemTimeDlgMul.js";
import businessScopeDlgMul from "./businessScopeDlgMul.js";
import workTmplDlg from "./workTmplDlg.js";

const qualitySystem = {
  namespaced: true,
  modules: {
    workItemDlgMul,
    workItemTimeDlgMul,
    businessScopeDlgMul,
    workTmplDlg
  }
};

export default qualitySystem;
